module.exports = __webpack_public_path__ + "img/Saudi Arabia.4a0e91e5.svg";